import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import InputField from '../Input/InputField';
import DefaultToken from './DefaultToken';
export function defaultRenderToken(token, _ref) {
  var keyboardControls = _ref.keyboardControls,
      removeToken = _ref.removeToken,
      selectFirstToken = _ref.selectFirstToken,
      selectLastToken = _ref.selectLastToken,
      selectNextToken = _ref.selectNextToken,
      selectPreviousToken = _ref.selectPreviousToken,
      tokenIndex = _ref.tokenIndex;
  return /*#__PURE__*/React.createElement(DefaultToken, {
    keyboardControls: keyboardControls,
    removeToken: removeToken,
    selectFirstToken: selectFirstToken,
    selectLastToken: selectLastToken,
    selectNextToken: selectNextToken,
    selectPreviousToken: selectPreviousToken,
    token: token,
    tokenIndex: tokenIndex
  });
}
export function defaultRenderInput(_ref2, _ref3) {
  var addToken = _ref3.addToken;

  var _onKeyDown = _ref2.onKeyDown,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["onKeyDown"]);

  return /*#__PURE__*/React.createElement(InputField, _extends({
    onKeyDown: function onKeyDown(e) {
      if (e.target.value !== '' && e.key === 'Enter') {
        addToken(e.target.value);
      }

      if (_onKeyDown) {
        _onKeyDown(e);
      }
    }
  }, restProps));
}